import { render, staticRenderFns } from "./matchmakerIntro.vue?vue&type=template&id=49096b7f&scoped=true"
import script from "./matchmakerIntro.vue?vue&type=script&lang=js"
export * from "./matchmakerIntro.vue?vue&type=script&lang=js"
import style0 from "./matchmakerIntro.vue?vue&type=style&index=0&id=49096b7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49096b7f",
  null
  
)

export default component.exports